module.exports = __webpack_public_path__ + "img/active-plan.ec331ae7.svg";